<template>
	<section class="experience-builder">
		<div class="experience-builder__selection">
			<div class="experience-builder__header" v-if="isPreregisteration">
				<h2>{{ headerPreregistrationText.title }}</h2>
				<div class="experience-builder__body" v-html="headerPreregistrationText.body"></div>
			</div>
			<div class="experience-builder__header" v-else>
				<h2>{{ headerText.title }}</h2>
				<div class="experience-builder__body" v-html="headerText.body"></div>
			</div>
			<ul class="experience-builder__list">
				<li
					class="experience-builder__list-item"
					v-for="(item, index) in availableSalesOptionsFiltered"
					:class="{
						'experience-builder__list-item--active': item.active,
						'experience-builder__list-item--complete': hasItemsInBasket(item)
					}"
					v-show="item.show"
					:key="index"
					@click="toggleSalesoption(item)"
				>
					<component :is="`icon-builder-${item.option}`" />

					<span class="experience-builder__label">{{ item.title }}</span>

					<!-- <IconLock v-if="item.isLocked" class="experience-builder__list-item-lock" /> -->
				</li>
			</ul>
		</div>

		<ul class="experience-builder__choices">
			<li v-for="(item, index) in availableSalesOptionsFiltered" :key="index">
				<ExperienceBlock
					class="experience-builder__block"
					:label="item.title"
					:data="item"
					:ref="item.slug || item.option"
					:is-disabled="shopCart && shopCart.status === 'confirmed'"
					v-show="item.show"
				/>
			</li>
		</ul>

		<Button class="button--alternative-second" @click.native="openCart" v-show="shopCart && totalPrice > 0">
			<span>{{ $t('label.go_to_checkout') }}</span>
		</Button>
	</section>
</template>

<script>
import ExperienceBlock from './components/ExperienceBlock';

export default {
	name: 'ExperienceBuilder',

	components: {
		ExperienceBlock
	},

	data() {
		return {
			availableSalesOptions: [],
			headerText: {
				title: this.$t('page.shop.experience_builder.title'),
				body: this.$t('page.shop.experience_builder.lead')
			},
			headerPreregistrationText: {
				title: this.$te('wish_list.experience_builder.title')
					? this.$t('wish_list.experience_builder.title')
					: this.$t('wish_list.experience_builder.title'),
				body: this.$te('wish_list.experience_builder.lead')
					? this.$t('wish_list.experience_builder.lead')
					: this.$t('wish_list.experience_builder.lead')
			}
		};
	},

	computed: {
		isPreregisteration() {
			return this.shopConfig.preregistration;
		},

		hasItemsInBasket(item) {
			const activeOptions = this.activeSalesOptions;

			return item => {
				const data = activeOptions.find(option => option.title === item.title);
				return data && data.basketData && data.basketData.length;
			};
		},

		totalPrice() {
			return this.shopCart.totalAmount;
		},

		activeSalesOptions() {
			return this.availableSalesOptions.filter(item => item.active);
		},

		getProductsArray() {
			return this.$store.getters['shopapi/getProducts'];
		},
		getTravelCart() {
			return this.$store.getters['shopconfig/getTravelCart'];
		},
		cartHasPolicy() {
			return this.$store.getters['shopconfig/getPolicyId'] ? true : false;
		},

		policyAllowsTravelOption() {
			//This should be replaced with an API call in the future
			return false;
		},

		availableSalesOptionsFiltered() {
			let optionsFiltered = [...this.availableSalesOptions];
			// console.log(this.previousOrderTravelItems);
			// Filter out tickets step:
			if (this.isMembershipInBasket || this.hasUpgradeModule) {
				optionsFiltered = this.availableSalesOptions.filter(option => option.option !== 'ticket');
			}
			if (Object.keys(this.previousOrderTravelItems).length) {
				if (optionsFiltered) {
					optionsFiltered = optionsFiltered.filter(item => item.option !== 'travel');
				}
			} else {
				optionsFiltered = optionsFiltered.filter(item => item.option !== 'traveladdon');
			}
			// Filter out other steps:
			const { upgradableOrder } = this.shopConfig;
			// console.log(upgradableOrder)
			if (upgradableOrder) {
				const skipSteps = [];
				upgradableOrder.skipTravel && skipSteps.push('travel');
				upgradableOrder.skipBus && skipSteps.push('transportation');
				optionsFiltered = optionsFiltered.filter(option => !skipSteps.includes(option.option));
			}

			//Salesoption should have active availble products, values are dynmaic due to potential policy settings
			optionsFiltered.forEach(item => {
				item.show = true;
				if (
					this.cartHasPolicy &&
					this.getProductsArray[item.option] &&
					!this.getProductsArray[item.option].length
				) {
					item.show = false;
				}
				//exception for travel, travel has differt logic so we need to check it separately
				if (
					!this.policyAllowsTravelOption &&
					this.cartHasPolicy &&
					item.option === 'travel' &&
					this.getTravelCart === null
				) {
					item.show = false;
				}
			});

			return optionsFiltered;
		},

		shopConfig() {
			return this.$store.getters['shopconfig/getData'];
		},

		shopCart() {
			return this.$store.getters['shopconfig/getCart'];
		},

		productsInBasket() {
			return this.$store.getters['shopapi/getMappedProductsInBasket'];
		},

		packageData() {
			const packages = this.$store.getters['travelapi/getPackages'];
			return packages ? packages.find(item => item.slug === this.$route.params.detail) : null;
		},

		isMembershipInBasket() {
			return !!this.productsInBasket.membership;
		},

		hasUpgradeModule() {
			return this.$store.getters['shopconfig/getHasUpgradeModule'];
		},

		isAddonShop() {
			return this.shopConfig.shopInit && this.shopConfig.shopInit.isAddOnShop;
			// return this.shopConfig.shopInit && true
		},

		previousOrderTravelItems() {
			const prevProducts = this.$store.getters['shopapi/getPurchasedProducts'];
			const prevOrders = prevProducts && prevProducts.data.data['original_orders'];
			const hasPrevTravelOrder = {};
			!!prevOrders &&
				prevOrders.forEach(order => {
					const orderReference = order.reference;
					order.purchases.forEach(purchase => {
						if (purchase.title.search('Travel:') != -1) {
							hasPrevTravelOrder[`${orderReference}`] = purchase;
						}
					});
				});
			// console.log('prevTravelOrder',hasPrevTravelOrder)
			return hasPrevTravelOrder;
		},
		useSalesOptions() {
			return this.$store.getters['shopconfig/getUseSalesOptions'];
		}
	},

	watch: {
		productsInBasket(val) {
			this.formatSalesOptions();
		}
	},

	methods: {
		translations(value) {
			return this.$t(`page.experience_builder.${value.option}`);
		},

		toggleSalesoption(value) {
			const toggledOption = this.availableSalesOptions.find(item => {
				if (item.slug) return item.slug === value.slug;

				return item.option === value.option;
			});
			const directLink = toggledOption.basketData === undefined;

			if (toggledOption && toggledOption.basketData != undefined) {
				if (toggledOption.slug) {
					this.scrollTo(
						this.$refs[toggledOption.slug][0].$el.getBoundingClientRect().top + (this.scrollPosition - 75)
					);
				} else {
					this.scrollTo(
						this.$refs[toggledOption.option][0].$el.getBoundingClientRect().top + (this.scrollPosition - 75)
					);
				}
				return;
			}

			if (toggledOption) {
				if (toggledOption.active && toggledOption.basketData) {
					this.removeItemsInCart(toggledOption);
				}

				toggledOption.active = true;

				// if (this.shopConfig.travelsale) {
				// 	if (toggledOption.option === 'ticket') {
				// 		// this.availableSalesOptions.find(item => item.option === 'travel').active = toggledOption.active;
				// 	} else if (toggledOption.option === 'travel') {
				// 		// this.availableSalesOptions.find(item => item.option === 'ticket').active = toggledOption.active;
				// 	}
				// }

				const temp = this.availableSalesOptions;
				this.availableSalesOptions = [];
				this.availableSalesOptions = temp;

				// this.updateCookie();

				/*
				 * When in preregister tickets only sale show a popup when visting travel in regards to ticket sale dates..
				 */
				if (toggledOption.option === 'travel' && this.shopConfig.preregistration && this.ticketOnlySale) {
					this.$fireErrorEvent(7000);
				}

				if (directLink) {
					const option = toggledOption.option === 'ticket' ? 'tickets' : toggledOption.option;
					const shop = this.$route.params.slug;

					if (this.useSalesOptions && (option === 'tickets' || option === 'extras')) {
						this.$router.push({
							path: `/${shop}/${option}/${toggledOption.slug}`,
							query: this.$route.query
						});
					} else {
						this.$router.push({
							path: `/${shop}/${option}`,
							query: this.$route.query
						});
					}
				}
			}
		},

		formatSalesOptions() {
			const salesOptions = [...this.shopConfig.salesOptions];
			/*
			 * Remove tickets in travel sale or when pre-register travel only is selected
			 */
			if (this.shopConfig.travelsale) {
				const index = salesOptions.findIndex(item => item.option === 'ticket');
				salesOptions.splice(index, 1);
			}

			salesOptions.forEach(option => {
				// Always activate all available options
				option.active = true;

				/*
				 * Ignore the travel tickets in the cart
				 */
				if (option.option === 'ticket' && this.productsInBasket[option.option]) {
					let removeTravelTickets = this.productsInBasket[option.option].filter(item => {
						const tickets =
							item.type.categories &&
							!item.type.categories.find(
								ticket => ticket.en === 'TRAVEL TICKETS' || ticket.nl === 'TRAVEL TICKETS'
							);
						return tickets;
					});

					removeTravelTickets = removeTravelTickets.length ? removeTravelTickets : undefined;
					option.basketData = removeTravelTickets;
				} else if (option.option === 'traveladdon' && this.productsInBasket['addon']) {
					option.basketData = this.productsInBasket['addon'];
				} else if (option.option === 'comparetransport' && this.productsInBasket['transportation']) {
					let tempArray = [];

					if (this.productsInBasket['transportation']) {
						tempArray = [...tempArray, ...this.productsInBasket['transportation']];
					}
					if (this.productsInBasket['comparetransport']) {
						tempArray = [...tempArray, ...this.productsInBasket['comparetransport']];
					}
					option.basketData = tempArray;
				} else {
					option.basketData = this.productsInBasket[option.option];
				}
			});

			/*
			 * Force rerender of ExperienceBlocks (seems to be the only way)
			 */
			this.availableSalesOptions = [];

			this.$nextTick(() => {
				this.availableSalesOptions = salesOptions;
				// this.updateCookie();
			});
		},

		removeItemsInCart(option) {
			if (option.title === 'Travel') {
				this.$store.dispatch('shopapi/deleteTravelCart');
				return;
			}

			this.$store.dispatch('shopapi/removeOptionFromExperienceBuilder', option.basketData);
		},

		openCart() {
			this.$store.commit('setShowCheckout', true);
		}
	},
	mounted() {
		this.formatSalesOptions();
	}
};
</script>

<style lang="scss">
$component: 'experience-builder';

.#{$component} {
	position: relative;

	max-width: 640px;
	// min-height: 50vh;

	margin: 0 auto;

	display: block;

	&:before {
		content: '';
		position: absolute;

		width: 1px;
		height: calc(100% - 5px);

		top: 0;
		left: calc(50% - 1px);

		background: rgba(var(--primary-color), 1);

		// transform: translateX(-50%);
		z-index: 0;
	}

	&__disabled {
		pointer-events: none;
	}

	&__selection {
		position: relative;

		margin-bottom: 50px;

		background-color: var(--content-background-light);

		border: 1px solid #5e5e66;
		box-shadow: inset 0px 0px 0px 2px $color-black;
	}

	&__header {
		text-align: center;
		padding: 20px;
	}

	&__body {
		display: block;
		font-size: 14px;
		padding-top: 8px;
	}

	&__list {
		display: flex;
	}

	&__list-item {
		position: relative;

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		cursor: pointer;

		width: 100%;
		height: 85px;

		background-image: linear-gradient(
			180deg,
			var(--content-background-dark) 0%,
			var(--content-background-light-2) 100%
		);
		border-top: 2px solid $color-black;

		> svg {
			path {
				fill: var(--primary-body-color);
			}
		}

		&:last-child {
			box-shadow: inset -2px -2px 0px 0px $color-black;
			border-left: 2px solid $color-black;

			&:after {
				// width: calc(100% - 4px);
				left: 0;
			}
		}

		&:not(:last-child) {
			box-shadow: inset 2px -2px 0px 0px $color-black;
		}

		&:after {
			content: '';

			position: absolute;
			display: none;

			width: calc(100% - 2px);
			height: 4px;

			bottom: 2px;
			left: 2px;

			// box-shadow: 0 2px 10px 0 rgba(0,0,0,0.50), inset 0 -8px 0 0 #F46C20;
			background-color: rgba(var(--primary-color), 1);
		}

		&--active {
			&:after {
				display: block;
			}
		}

		&--complete {
			&:after {
				// box-shadow: 0 2px 10px 0 rgba(0,0,0,0.50), inset 0 -8px 0 0 green;
				background-color: green;
				display: block;
			}
		}
	}

	&__list-item-lock {
		position: absolute;

		top: 7px;
		right: 8px;

		opacity: 0.8;
	}

	&__label {
		text-transform: capitalize;
		font-size: 10px;
		font-family: $font-bold;

		padding-top: 10px;
	}

	&__block {
		margin-bottom: 50px;

		box-shadow: 0 2px 16px rgba(black, 0.5);
	}
}
</style>
